import PlazaConfig from './stores/14766';
import NetherlandConfig from './stores/3714';
import CompostelaConfig from './stores/6460';
import PortoSantaCatarinaConfig from './stores/301';
import BuenosAiresItaliaConfig from './stores/3327';
import BatterseaConfig from './stores/14512';
import JuanDeAustriaConfig from './stores/12477';
import ChampsElyseesConfig from './stores/14914';
import AreseShoppingCenterConfig from './stores/6437';
import MilVittorioEmmanueleConfig from './stores/3197';
import DubaiMoEConfig from './stores/3488';
import RoterdamConfig from './stores/14965';
import SevillaDuqueConfig from './stores/16231';

export const getStoreConfig = (storeId) => {
  switch (storeId) {
    case '14766':
      return PlazaConfig;
    case '3714':
      return NetherlandConfig;
    case '6460':
      return CompostelaConfig;
    case '301':
      return PortoSantaCatarinaConfig;
    case '3327':
      return BuenosAiresItaliaConfig;
    case '14512':
      return BatterseaConfig;
    case '12477':
      return JuanDeAustriaConfig;
    case '14914':
      return ChampsElyseesConfig;
    case '6437':
      return AreseShoppingCenterConfig;
    case '3197':
      return MilVittorioEmmanueleConfig;
    case '3488':
      return DubaiMoEConfig;
    case '14965':
      return RoterdamConfig;
    case '16231':
      return SevillaDuqueConfig;
    default:
      return PlazaConfig;
  }
};

export const tenantGooglePlayAppUrl =
  'https://play.google.com/store/apps/details?id=com.inditex.zara';
export const tenantAppStoreAppUrl =
  'https://apps.apple.com/es/app/zara/id547951480?mt=8';
export const tenantName = 'ZARA';
